export enum Permission {
  AdminPanel = 'admin_panel.legacy_permission',
  PageBuilderModify = 'page_builder.modify',
  PageBuilderView = 'page_builder.view',
  StoreConfigsModify = 'store_configs.modify',
  StoreConfigsView = 'store_configs.view',
}
